export default "__VITE_ASSET__CUVXjAw5__"